import MapInfo from "../interfaces/cleaning-map/map-info";
import { remapImagePixels } from "../interfaces/cleaning-map/pixel-color-type";

export const getMapCoordinatesFromPoint = (
  point: { x: number; y: number },
  mapDimensions: { height: number; resolution: number; xPosition: number; yPosition: number },
  absYPosition: boolean = false
) => {
  const yPosition = absYPosition ? Math.abs(mapDimensions.yPosition) : mapDimensions.yPosition;

  return {
    x: (point.x - mapDimensions.xPosition) / mapDimensions.resolution,
    y: mapDimensions.height - (point.y - yPosition) / mapDimensions.resolution,
  };
};

export const drawImageToCanvas = (
  canvas: HTMLCanvasElement,
  primaryMapInfo: MapInfo,
  mapInfo: MapInfo,
  isCoverage: boolean,
  contextCallback?: (context: CanvasRenderingContext2D) => void
) => {
  const context = canvas.getContext("2d");
  if (!context) return;

  const base64ToBlobUrl = (base64: string): string => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "image/png" });
    return URL.createObjectURL(blob);
  };

  const img = new Image();
  img.src = base64ToBlobUrl(mapInfo.map)

  img.onload = () => {
    const offscreenCanvas = document.createElement("canvas");
    offscreenCanvas.width = primaryMapInfo.width;
    offscreenCanvas.height = primaryMapInfo.height;
    const offscreenContext = offscreenCanvas.getContext("2d");
    if (!offscreenContext) return;

    const scale = mapInfo.resolution / primaryMapInfo.resolution;

    const overlayWidth = mapInfo.width * scale;
    const overlayHeight = mapInfo.height * scale;

    const offsetX = (mapInfo.originX - primaryMapInfo.originX) / primaryMapInfo.resolution;
    const offsetY =
      (primaryMapInfo.originY - mapInfo.originY) / primaryMapInfo.resolution + (primaryMapInfo.height - overlayHeight);

    offscreenContext.drawImage(img, 0, 0, mapInfo.width, mapInfo.height, offsetX, offsetY, overlayWidth, overlayHeight);

    let imageData: ImageData;
    try {
      imageData = remapImagePixels(
        offscreenContext.getImageData(0, 0, primaryMapInfo.width, primaryMapInfo.height),
        isCoverage
      );
    } catch (e) {
      console.error("Error drawing image to canvas:", e);
      return;
    }

    offscreenContext.putImageData(imageData, 0, 0);

    canvas.width = primaryMapInfo.width;
    canvas.height = primaryMapInfo.height;
    context.drawImage(offscreenCanvas, 0, 0); // Draw from the offscreen canvas

    contextCallback?.(context);

    offscreenCanvas.remove();
  };
};
